import { render, staticRenderFns } from "./GeneralSettingsTab.vue?vue&type=template&id=0cfc7f4a&scoped=true&"
import script from "./GeneralSettingsTab.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingsTab.vue?vue&type=style&index=0&id=0cfc7f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc7f4a",
  null
  
)

export default component.exports